import { render, staticRenderFns } from "./TheNovelJoin.vue?vue&type=template&id=1891f564&scoped=true"
import script from "./TheNovelJoin.vue?vue&type=script&lang=ts"
export * from "./TheNovelJoin.vue?vue&type=script&lang=ts"
import style0 from "./TheNovelJoin.vue?vue&type=style&index=0&id=1891f564&prod&lang=scss&scoped=true"
import style1 from "./TheNovelJoin.vue?vue&type=style&index=1&id=1891f564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1891f564",
  null
  
)

export default component.exports